if (!customElements.get('sb-scroll-top')) {
  customElements.define(
    'sb-scroll-top',
    class SbScrollTop extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.button = this.querySelector('button');
        this.updateVisibility = () => this.classList.toggle('is-visible', window.scrollY > 600);
        this.button?.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            window.scrollTo(0, 0);
          },
          { signal },
        );
        window.addEventListener('scroll', this.updateVisibility, { passive: true, signal });
        this.updateVisibility();
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    },
  );
}
